"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  id: "Table",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "outline-table_chart-24px",
    transform: "translate(1.000000, 1.000000)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Bounding_Boxes",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
        id: "Shape",
        points: "0 0 22 0 22 22 0 22"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Outline",
      transform: "translate(2.750000, 2.750000)",
      fill: "currentColor",
      fillRule: "nonzero",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M15.5833333,0 L1.83333333,0 C0.825,0 0,0.825 0,1.83333333 L0,14.6666667 C0,15.675 0.825,16.5 1.83333333,16.5 L15.5833333,16.5 C16.5916667,16.5 17.4166667,15.675 17.4166667,14.6666667 L17.4166667,1.83333333 C17.4166667,0.825 16.5916667,0 15.5833333,0 Z M15.5833333,1.83333333 L15.5833333,4.58333333 L1.83333333,4.58333333 L1.83333333,1.83333333 L15.5833333,1.83333333 Z M11,14.6666667 L6.41666667,14.6666667 L6.41666667,6.41666667 L11,6.41666667 L11,14.6666667 Z M1.83333333,6.41666667 L4.58333333,6.41666667 L4.58333333,14.6666667 L1.83333333,14.6666667 L1.83333333,6.41666667 Z M12.8333333,14.6666667 L12.8333333,6.41666667 L15.5833333,6.41666667 L15.5833333,14.6666667 L12.8333333,14.6666667 Z",
        id: "Shape"
      })
    })]
  })
}));